import { __awaiter, __generator } from "tslib";
import _get from 'lodash/get';
export default function HandshakeServerApi(_a) {
    var handshakeAgent = _a.handshakeAgent;
    return {
        http$getToken: function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, chatToken;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, handshakeAgent.post('chat-tokens')];
                        case 1:
                            response = _a.sent();
                            chatToken = _get(response, ['data', 'chatToken']);
                            if (chatToken) {
                                return [2 /*return*/, chatToken];
                            }
                            throw Error("no token: " + response);
                    }
                });
            });
        }
    };
}
